import Superstore from '../superstore';
import models from './models';

export default new Superstore({
    debug: false,
    models
});
